import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken, getSubSiteId } from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/apiadmin',
  timeout: 30000
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['admintoken'] = token
    }
    const subSiteId = store.getters.subSiteId
    if (subSiteId !== undefined && subSiteId !== null && subSiteId !== '') {
      config.headers['subsite'] = String(subSiteId)
    } else if (getSubSiteId() !== undefined) {
      config.headers['subsite'] = String(getSubSiteId())
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res && typeof res.code !== 'undefined') {
      if (res.code === 0) {
        return res.data
      }
      const msg = res.message || res.msg || '请求失败'
      if (res.code === 50001) {
        Message.error('登录已失效，请重新登录')
        store.dispatch('user/resetToken').then(() => {
          location.hash = '#/login'
        })
      } else {
        Message.error(msg)
      }
      return Promise.reject(new Error(msg))
    }
    return res
  },
  error => {
    Message.error(error.message || '网络错误')
    return Promise.reject(error)
  }
)

export default service
